import { Navigate, Route, Routes } from "react-router-dom";
import LanguageLayout from "./languages/languagesLayout";
import Index from "./main";
import AboutUs from "./main/aboutus";
import Blogs from "./main/blogs";
import ContactUs from "./main/contactus";
import React from "react";
import Error404 from "./component/404";
import LanguageValidator from "./component/LanguageValidator";

const Routers = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate to={`/hy`} replace />} />

            <Route path="/404" element={<Error404 />} />

            <Route path="/:lng" element={<LanguageValidator />}>
                <Route element={<LanguageLayout />}>
                    <Route index element={<Index />} />
                    <Route path="about" element={<AboutUs />} />
                    <Route path="enterprises" element={<Blogs />} />
                    <Route path="contact-us" element={<ContactUs />} />
                    <Route path="*" element={<Error404 />} />
                </Route>
            </Route>

            <Route path="*" element={<Error404 />} />
        </Routes>
    );
};

export default Routers;
